import { render, staticRenderFns } from "./ApplicationsList.vue?vue&type=template&id=9357fda2"
import script from "./ApplicationsList.vue?vue&type=script&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports